import { ScrollingModule } from '@angular/cdk/scrolling';
import { Component, ElementRef, HostListener, computed, inject, input, signal } from '@angular/core';
import { VehicleModel } from '../../../../core/models/vehicle.model';

const CARD_MIN_WIDTH = 160;
const GRID_GAP = 12;
const CARD_HEIGHT = 56;

interface ModelRow {
  id: number;
  models: VehicleModel[];
}

@Component({
  selector: 'app-models-list',
  imports: [ScrollingModule],
  templateUrl: './models-list.html',
  styleUrl: './models-list.scss',
})
export class ModelsList {
  readonly models = input<VehicleModel[]>([]);
  readonly loading = input(false);
  readonly error = input<string | null>(null);
  readonly ready = input(false);

  protected readonly rowHeight = CARD_HEIGHT + GRID_GAP;

  private readonly hostRef = inject(ElementRef<HTMLElement>);
  private readonly columns = signal(this.computeColumns());

  protected readonly gridTemplateColumns = computed(() => `repeat(${this.columns()}, 1fr)`);

  // Chunked into rows so the CDK viewport, which virtualizes one axis, can virtualize the grid.
  protected readonly rows = computed<ModelRow[]>(() => {
    const models = this.models();
    const columns = this.columns();
    const result: ModelRow[] = [];
    for (let i = 0; i < models.length; i += columns) {
      const slice = models.slice(i, i + columns);
      result.push({ id: slice[0].id, models: slice });
    }
    return result;
  });

  @HostListener('window:resize')
  protected onResize(): void {
    this.columns.set(this.computeColumns());
  }

  protected trackRow(_index: number, row: ModelRow): number {
    return row.id;
  }

  private computeColumns(): number {
    const width = this.hostRef.nativeElement.clientWidth;
    if (!width) {
      return 1;
    }
    return Math.max(1, Math.floor((width + GRID_GAP) / (CARD_MIN_WIDTH + GRID_GAP)));
  }
}
